export function getLatestCreatedDrawing(draw: any) {
  // const draw = getDraw();
  const FeatureCollection = draw.getAll();
  const features = FeatureCollection.features;
  return features.length === 0 ? null : features[0];
}
